module.exports = __webpack_public_path__ + "img/peter_millar.25abde23.png";